<template>
  <SectionBuilder
    v-if="content"
    v-bind="content"
  />
</template>

<script setup lang="ts">
import SectionBuilder from '~/components/Organisms/SectionBuilder/SectionBuilder.vue';
import type { MediaTwoColumnSecondaryBlock } from '~/sanity/types';

defineProps<MediaTwoColumnSecondaryBlock>();
</script>

<style scoped></style>
